import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const experienceSchema = itemSchema
  .extend({
    company: z.string().min(1).max(50),
    position: z.string().max(50),
    location: z.string().max(50),
    date: z.string(),
    fromDate: z.string(),
    toDate: z.string(),
    summary: z.string().max(1000),
    currently_working: z.boolean(),
    url: urlSchema,
  })
  .refine(
    (data) => {
      const [day, month, year]: any = data.fromDate.split("-");
      const [to_day, to_month, to_year]: any = data.toDate.split("-");
      return new Date(year, month - 1, day) <= new Date(to_year, to_month - 1, to_day);
    },
    {
      message: "End date must be after start date",
      path: ["toDate"],
    },
  );

// Type
export type Experience = z.infer<typeof experienceSchema>;
let cur_date = new Date();
cur_date.setDate(cur_date.getDate() + 1);

export const defaultExperience: Experience = {
  ...defaultItem,
  company: "",
  position: "",
  location: "",
  date: "",
  fromDate: new Date().toISOString().split("T")[0].split("-").reverse().join("-"),
  toDate: new Date().toISOString().split("T")[0].split("-").reverse().join("-"),
  summary: "",
  currently_working: false,
  url: defaultUrl,
};
